import { CSSProperties } from "react";

import MeqLoading from "~/assets/icons/meq-loading.svg?react";

import SvgIconRaw, { IconName } from "./SvgIconRaw";

export type { IconName };

export type SvgIconProps = {
  name: IconName;
  size?: number | string;
  fill?: string;
  color?: string;
  strokeWidth?: number | string;
  style?: CSSProperties;
};

const SvgIcon = ({
  name,
  size,
  fill,
  color,
  strokeWidth,
  style,
}: SvgIconProps) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: size || "1.5rem",
      height: size || "1.5rem",
      ...style,
    }}
  >
    <SvgIconRaw
      name={name}
      size={size || "1.5rem"}
      fill={fill || "none"}
      color={color || "var(--mantine-color-text-secondary)"}
      strokeWidth={strokeWidth || 2}
    />
  </span>
);

export default SvgIcon;

export { MeqLoading };
